
import { Error404 } from "../../components/error"

export default function Error () {

  return (
    <>
      <Error404/>
    </>
  )

}